import { Link } from "react-router-dom";
import CandidateListItem from "./candidate-list-item";
import { ChatParticipant } from "@/types/chat";

interface NewChatsListProps {
  matches: ChatParticipant[];
  selectedAdId: string;
  selectedChats: string[];
  setSelectedChats: React.Dispatch<React.SetStateAction<string[]>>;
}

const NewChatsList = ({
  matches,
  selectedAdId,
  selectedChats,
  setSelectedChats,
}: NewChatsListProps) => {
  if (matches.length === 0) {
    return (
      <div className="text-center text-sm text-gray-500">
        Inga chattar hittades
      </div>
    );
  }

  const getPreviewMessage = (match: ChatParticipant) => {
    if (match.latestMessage) {
      return match.latestMessage;
    }

    return {
      message: "Ny match! Starta en konversation.",
      timestamp: match.timestamp,
      sender: "system",
    };
  };

  return (
    <div>
      {matches.map((match: ChatParticipant) => (
        <Link
          to={`/chat/${selectedAdId}/${match.uid}`}
          key={match.uid + selectedAdId}>
          <CandidateListItem
            key={match.uid}
            candidate={match}
            selectedAdId={selectedAdId}
            selectedChats={selectedChats}
            setSelectedChats={setSelectedChats}
            previewMessage={getPreviewMessage(match)}
          />
        </Link>
      ))}
    </div>
  );
};

export default NewChatsList;
